module.exports = __webpack_public_path__ + "static/img/yytx30.2f3ad17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx30.png
// module id = 808
// module chunks = 0